import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  ServiceTransactionInitState
} from '@/store/service-transaction/service-transaction.types';
import {Toast} from '@/store/toast/toast.types';
import {MemberInitState, MemberTimeInformation} from '@/store/member/member.types';
import {FormValidate} from '@/services/form-validate';
import {PointTransfer, TimeTransactionInitState} from '@/store/time-transaction/time-transaction.types';

@Component({
  components: {}
})
export default class TransferFormComponent extends Vue {
  @State('timeTransaction') timeTransactionInitState!: TimeTransactionInitState;

  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @State('member') memberInitState!: MemberInitState;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getTimeInformation', {namespace: 'member'}) getTimeInformation!: () => Promise<void>;
  @Action('_transfer', {namespace: 'timeTransaction'}) transfer!: (body: PointTransfer) => Promise<void>;
  public showPassword: boolean = true;

  public timeInformation = {} as MemberTimeInformation;
  public max = 0;
  public transferForm = {} as PointTransfer;

  async mounted() {
    try {
      if (this.serviceTransactionInitState.jobRunning.id) {
        this.$router.push('/payment-information').then();
      }
      await this.getTimeInformation();
      this.timeInformation = this.memberInitState.timeInformation;
      this.max = parseInt(this.timeInformation.timeTransactions[0].remain);
    } catch (e) {
      this.transferHandleError(e)
    }
  }

  async transferClick() {
    let forms = document.getElementsByClassName('transferForm');
    let valid = FormValidate.validate(forms);
    if (!valid) {
      this.Toast({
        heading: '!',
        message: 'กรุณากรอกข้อมูลตามที่กำหนด',
        type: 'danger'
      }).then();
      return;
    }
    await this.transfer(this.transferForm);
    this.Toast({
      message: 'บันทึกข้อมูลสำเร็จ',
      heading: `สำเร็จ`,
      type: 'success',
    }).then();
    let id = this.timeTransactionInitState.timeTransactions[0].id;
    this.$router.push({
      path: `/transfer/${id}`
    }).then();
  }

  transferHandleError(e: any) {
    console.log('DEBUG: e', e);
  }
}


